import { HTMLAttributes, ReactNode } from "react";

type Props = {
  title?: string;
  subTitle?: string;
  children?: ReactNode;
  subTitleClass?: string;
} & HTMLAttributes<HTMLDivElement>;

export default function Subheader({
  title,
  subTitle,
  children,
  subTitleClass,
  ...rest
}: Props) {
  return (
    <div
      className="p-4 justify-between items-center flex flex-wrap bg-status-complete-bg gap-3 sub_header shadow rounded-t-md shadow-gray-200"
      {...rest}
    >
      <div>
        <h3 className="text-primary-np text-[22px] font-semibold title">
          {title}
        </h3>
        {subTitle ? (
          <h6
            className={`text-primary-np text-base font-medium mt-1 ${subTitleClass}`}
          >
            {subTitle}
          </h6>
        ) : null}
      </div>
      {children && <div className="ml-auto">{children}</div>}
    </div>
  );
}
